import { NavItem, NavListItemWithBlockDescriptionValue } from '@billy/design-system'
import { TFunction } from 'i18next'
import orderBy from 'lodash/orderBy'

import { Bank } from '@features/openBanking/types/bank'
import { Country } from '@modules-deprecated/app/countries/types'

import { LogoShine } from '../../../../../assets/images'
import { BankLogo } from '../elements/BankLogo'
import { isSearchQueryMatchForNameOrCountry } from './isSearchQueryMatchForNameOrCountry'
import { prioritizeExactMatches } from './prioritizeExactMatches'

export type BankValue = NavListItemWithBlockDescriptionValue

export const SHINE_BANK_ID = 'shine-bank'

const shineBank: Bank = {
  id: SHINE_BANK_ID,
  externalId: SHINE_BANK_ID,
  name: 'Shine',
  countryCode: 'FR',
  presentation: '',
}

interface GetBankItemsProps {
  banks: Bank[]
  countries?: Country[]
  currentOrgCountryId?: string
  searchQuery: string
  shouldSeeShineBank: boolean
  t: TFunction
}

export const getBankItems = ({
  banks,
  countries,
  currentOrgCountryId,
  searchQuery,
  shouldSeeShineBank,
  t,
}: GetBankItemsProps): NavItem<BankValue>[] => {
  const includedBanks = shouldSeeShineBank ? [shineBank, ...banks] : banks
  const bankItems = includedBanks.map((bank: Bank) => {
    const country = countries?.find((country) => country.id === bank.countryCode)
    const bankName = bank.name || t('bankreconciliation.connect_bank.banks.unknown_name')
    const bankCountry = country?.name || t('bankreconciliation.connect_bank.banks.unknown_country')
    const bankLogoUrl = bank.presentation || ''

    return {
      id: bank.id,
      children: bankName,
      leftDecoration:
        bank.id === SHINE_BANK_ID ? (
          <LogoShine width="48" height="48" />
        ) : (
          <BankLogo name={bankName} logoUrl={bankLogoUrl} />
        ),
      value: {
        ...bank,
        displayData: {
          title: bankName,
          description: bankCountry,
        },
      },
    }
  })

  const bankItemsFiltered = orderBy(
    bankItems.filter((bank) =>
      isSearchQueryMatchForNameOrCountry(bank.children, bank.value.displayData.description, searchQuery),
    ),
    [
      (bank) => prioritizeExactMatches(bank.children, searchQuery),
      (bank) => currentOrgCountryId !== bank.value.countryCode,
    ],
    ['asc', 'asc'],
  )

  return bankItemsFiltered
}
